"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RouteAPI = void 0;

require("core-js/modules/web.dom.iterable");

var _defineProperty2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _request = require("@/services/request/request.service");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var RouteAPI = /*#__PURE__*/function () {
  function RouteAPI(_ref) {
    var customerKey = _ref.customerKey,
        userSetting = _ref.userSetting;
    (0, _classCallCheck2.default)(this, RouteAPI);
    this.settings = {};
    this.customerKey = null;
    this.requestAuth = null;
    this.requestParameters = null;
    this.customerKey = customerKey;
    this.settings = userSetting;
    this.requestAuth = new _request.Request('application/json', process.env.VUE_APP_SECRET_KEY_HASH);
    this.requestParameters = (0, _defineProperty2.default)({}, process.env.VUE_APP_CUSTOMER_KEY, this.customerKey);
  }

  (0, _createClass2.default)(RouteAPI, [{
    key: "arrayStringDefault16",
    value: function arrayStringDefault16(data) {
      var newData = [];
      data.forEach(function (obj) {
        newData.push("".concat(obj['truck'], "-").concat(obj['commodity']));
      });
      return newData.join('|');
    }
  }, {
    key: "scheduleAssign",
    value: function scheduleAssign(payload) {
      return this.requestAuth.post('AI_ROUTE', 'schedule', _objectSpread(_objectSpread({}, this.requestParameters), {}, {
        // google: this.settings['default5'] || false,
        google: false,
        waitingTime: this.settings['default7'] || 0,
        handlingTime: this.settings['default8'] || 0,
        maxDistance: this.settings['default11'] || 24,
        totalMaxDistance: this.settings['default26'] || 100
      }), payload);
    }
  }, {
    key: "manualAssign",
    value: function manualAssign(payload) {
      var isTransfer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var isTimeWindowCheck = this.settings['default2'];
      var endpoint;

      var params = _objectSpread(_objectSpread({}, this.requestParameters), {}, {
        // removeOverflow: this.settings['default1'] || false,
        removeOverflow: true,
        returnVehicle: this.settings['default3'] || false,
        capacity: this.settings['default9'] || false,
        // google: this.settings['default5'] || false,
        google: false,
        waitingTime: this.settings['default7'] || 0,
        handlingTime: this.settings['default8'] || 0,
        maxDistance: this.settings['default11'] || 24,
        totalMaxDistance: this.settings['default26'] || 100,
        capacity3TimeBuffer: this.settings['default15'] || 0,
        travelTimePadding: this.settings['default29'] || 0,
        capacityPadding: this.settings['default33'] || 0,
        truckCommodityTypeMapping: this.settings['default16'] ? this.arrayStringDefault16(this.settings['default16']) : '',
        additionalConstraints: this.settings['default12'] || ''
      });

      if (isTimeWindowCheck) {
        endpoint = !isTransfer ? 'timewindowmanual' : 'timewindowmanualtransfer';
        params['timeWindowBuffer'] = this.settings['default13'] || 0;
        params['groupByTimeWindow'] = this.settings['default24'] || false;
        params['groupByWeekDate'] = this.settings['default32'] || false;
      } else {
        endpoint = !isTransfer ? 'manual' : 'manualtransfer';
      }

      return this.requestAuth.post('AI_ROUTE_V2', endpoint, params, payload);
    }
  }, {
    key: "autoAssign",
    value: function autoAssign(payload) {
      var locationType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'drop';
      var isTimeWindowCheck = this.settings['default2'];
      var endpoint;

      var params = _objectSpread(_objectSpread({}, this.requestParameters), {}, {
        // removeOverflow: this.settings['default1'] || false,
        removeOverflow: true,
        returnVehicle: this.settings['default3'] || false,
        group: this.settings['default4'] || false,
        optimizeTruck: this.settings['default20'] || false,
        // google: this.settings['default5'] || false,
        google: false,
        waitingTime: this.settings['default7'] || 0,
        handlingTime: this.settings['default8'] || 0,
        maxDistance: this.settings['default11'] || 24,
        totalMaxDistance: this.settings['default26'] || 100,
        capacity3TimeBuffer: this.settings['default15'] || 0,
        travelTimePadding: this.settings['default29'] || 0,
        capacityPadding: this.settings['default33'] || 0,
        truckCommodityTypeMapping: this.settings['default16'] ? this.arrayStringDefault16(this.settings['default16']) : '',
        additionalConstraints: this.settings['default12'] || ''
      });

      if (isTimeWindowCheck) {
        endpoint = "timewindowauto-".concat(locationType);
        params['timeWindowBuffer'] = this.settings['default13'] || 0;
        params['groupByTimeWindow'] = this.settings['default24'] || false;
        params['groupByWeekDate'] = this.settings['default32'] || false;
      } else {
        endpoint = "auto-".concat(locationType);
      }

      return this.requestAuth.post('AI_ROUTE_V2', endpoint, params, payload);
    }
    /*adhocAssign(payload, param?) {
        return this.requestAuth.post(
            'AI_ROUTE_V2',
            'manual',
            {
                ...this.requestParameters,
                capacity: this.settings['default9'] || false,
                // google: this.settings['default5'] || false,
                google: false,
                waitingTime: this.settings['default7'] || 0,
                handlingTime: this.settings['default8'] || 0,
                maxDistance: this.settings['default11'] || 24,
                totalMaxDistance: this.settings['default26'] || 100,
                capacity3TimeBuffer: this.settings['default15'] || 0,
                truckCommodityTypeMapping: this.settings['default16']
                    ? this.arrayStringDefault16(this.settings['default16'])
                    : '',
                additionalConstraints: this.settings['default12'] || '',
                ...param,
            },
            payload
        );
    }*/

  }, {
    key: "adhocAssignV2",
    value: function adhocAssignV2(payload) {
      var param = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.requestAuth.post('AI_ROUTE_V2', 'adhocmanual', _objectSpread(_objectSpread({}, this.requestParameters), {}, {
        // removeOverflow: this.settings['default1'] || false,
        removeOverflow: true,
        // google: this.settings['default5'] || false,
        google: false,
        waitingTime: this.settings['default7'] || 0,
        handlingTime: this.settings['default8'] || 0,
        maxDistance: this.settings['default11'] || 24,
        totalMaxDistance: this.settings['default26'] || 100,
        combineRoute: true
      }, param), payload);
    }
  }, {
    key: "calculateETA",
    value: function calculateETA(payload) {
      return this.requestAuth.post('AI_ROUTE', 'calculate', _objectSpread(_objectSpread({}, this.requestParameters), {}, {
        lock: payload.locked
      }), payload);
    }
  }, {
    key: "removeCompletedOrders",
    value: function removeCompletedOrders(payload) {
      return this.requestAuth.post('AI_ROUTE', 'remove', _objectSpread({}, this.requestParameters), payload);
    }
  }, {
    key: "getAllZones",
    value: function getAllZones() {
      return this.requestAuth.get('AI_ROUTE', 'zoning', this.requestParameters);
    }
  }, {
    key: "generateLoadPlanId",
    value: function generateLoadPlanId(prefix, number) {
      return this.requestAuth.put('AI_ROUTE', 'plannumber', this.requestParameters, {
        prefix: prefix,
        number: number
      });
    }
  }]);
  return RouteAPI;
}();

exports.RouteAPI = RouteAPI;